import {
    warningColor,
    primaryColor,
    dangerColor,
    successColor,
    infoColor,
    roseColor,
    grayColor,
    defaultFont
} from "../../../App/styles";
import red from '@material-ui/core/colors/red';

const styles = theme => ({
    warningTableHeader: {
        color: warningColor
    },
    primaryTableHeader: {
        color: primaryColor
    },
    dangerTableHeader: {
        color: dangerColor
    },
    successTableHeader: {
        color: successColor
    },
    infoTableHeader: {
        color: infoColor
    },
    roseTableHeader: {
        color: roseColor
    },
    grayTableHeader: {
        color: grayColor
    },
    table: {
        width: "100%",
        maxWidth: "100%",
        backgroundColor: "transparent",
        borderSpacing: "0",
        borderCollapse: "collapse"
    },
    tableHeadCell: {
        color: "inherit",
        ...defaultFont,
        fontSize: "1.4em"
    },
    tableCell: {
        ...defaultFont,
        lineHeight: "1.42857143",
        padding: "12px 8px",
        verticalAlign: "middle",
        fontSize: "1.4em",
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderLeft: '1px solid',
        borderRight: '1px solid',
    },
    tableResponsive: {
        width: "100%",
        marginTop: theme.spacing.unit * 3,
        overflowX: "auto"
    },
    tablePaginationRoot: {
        bottom: 0,
        right: 0,
    },
    tablePaginationCaption: {
        ...defaultFont,
        fontSize: 15
    },
    wrapperContainer: {
        position: 'relative',
    },
    loadingProgress: {
        color: red[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
    },
    normal_row: {
    },
    highlight_row: {
        background: 'yellow',
    },
});
    
export default styles;
